export default function getUserIdFromLocalStorage(): string {
	return JSON.parse(window.localStorage.getItem("jamUser") as string)._id
}
